<template>
  <div id="homepage" class="c-content">
    <div class="c-content__carousel">
      <q-carousel class='c-carousel__height' swipeable animated v-model="slide" infinite navigation navigation-icon='fa fa-circle-o' navigation-active-icon='fa fa-circle' transition-prev="slide-right" transition-next="slide-left">
        <q-carousel-slide v-for="(item, index) in banner" :name="index" :img-src="item.img" :key="index">
          <div :class="item.className">
            <h1>{{ item.title1 }}</h1>
            <p>{{ item.content }}</p>
          </div>
        </q-carousel-slide>
      </q-carousel>
    </div>

    <image-block-bottom></image-block-bottom>

    <image-block-bg></image-block-bg>
    <div class="c-introduce">
      <h3 class='title_h3 relative'>
        <span>{{ text.introduceTitle }}</span>
        <div class="textBgCenter absolute" style='top: -50%; background-color: rgba(45, 160, 91, .5)'></div>
      </h3>
      <div class="c-introduce_content">
        <div class="c-introduce__block" v-for="(item,index) in introduce" :key="index">
          <div>
            <img :src="item.img" :alt="item.title">
            <h2>{{item.title}}</h2>
          </div>
          <p>{{item.text}}</p>
        </div>
      </div>
    </div>

    <product-list></product-list>



    <case-block style='padding-top: 0'></case-block>


  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'
  import CaseBlock from '../layout/caseBlock.vue'
  import ImageBlockBottom from '../layout/imageBlockBottom.vue'
  import ImageBlockBg from '../layout/imageBlockBg.vue'
  import ProductList from '../layout/productList.vue'

  export default {
    name: 'homepage',
    components: {
      'q-carousel': Quasar.QCarousel,
      'q-carousel-slide': Quasar.QCarouselSlide,
      'q-btn': Quasar.QBtn,
      'case-block': CaseBlock,
      'image-block-bottom': ImageBlockBottom,
      'image-block-bg': ImageBlockBg,
      'product-list': ProductList
    },
    data(){
      return {
        text: {
          more: this.$t('common.more'),
          introduceTitle: this.$t('homepage.introduce.title')
        },
        slide: 0,
        banner: [
          {img: require('../../assets/img/homebanner_a.jpg'), title1:this.$t('homepage.banner.banner_1.title'), title2:"",content:this.$t('homepage.banner.banner_1.content'), className: "absolute-center c-carousel__block c-carousel__block--first"},
        ],
        introduce: [
          {title: this.$t('homepage.introduce.introduce_1.title'), img: require('../../assets/img/icon_home.png'), text: this.$t('homepage.introduce.introduce_1.content')},
          {title: this.$t('homepage.introduce.introduce_2.title'), img: require('../../assets/img/icon_community.png'), text: this.$t('homepage.introduce.introduce_2.content')},
          {title: this.$t('homepage.introduce.introduce_3.title'), img: require('../../assets/img/icon_mechanism.png'), text: this.$t('homepage.introduce.introduce_3.content')},
        ],
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
  }
</script>

<style>

</style>
